import { createHttpLink } from "@apollo/client";
import { getServerURL } from "src/modules/debug/utils";
const serverURL = getServerURL();
const httpLink = createHttpLink({
    uri: ({ operationName }) => `${serverURL}/graphql?opName=${operationName}`,
});
export default httpLink;
